import {
    Checkbox,
    CheckboxProps,
    FluentProvider,
    PartialTheme,
    webDarkTheme,
    webLightTheme
} from "@fluentui/react-components";
import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";

interface CheckboxCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
}

const CheckboxCustom = (props: CheckboxCustomProps & CheckboxProps) => {
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles
  );

  return props.theme ? (
    <FluentProvider
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
              ...renderTheme,
              colorCompoundBrandBackground: "rgb(70, 101, 136)",
              colorCompoundBrandBackgroundHover: "rgb(21, 51, 89)",
            }
      }
    >
      <Checkbox {...props} disabled={props.disabled || !isCanBeVisible} />
    </FluentProvider>
  ) : (
    <Checkbox {...props} />
  );
};

export default CheckboxCustom;
